import {
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import searchicon from "../../../assets/icons/Group 26079.svg";
import filtericon from "../../../assets/icons/Group 26123@2x.png";
import UserPredictionListingComp from "../../../components/userPredictionListing/userPredictionListingComp";
import { useDispatch, useSelector } from "react-redux";
import { getUserPredictionPost } from "../../../redux/actions/pollingAction";
import NothingFound from "../../../pages/search-result/NothingFound";
import { pollPredictionHandler } from "../../../helpers/utilities";
import { BASE_URL_PP } from "../../../redux/api";

const PredictionPostListing = () => {
  const [render, setRender] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [openCommentId, setOpenCommentId] = useState(null);
  const [openShareId, setOpenShareId] = useState(null);
  const [yearlist, setYearList] = useState([])
  const [statelist, setStateList] = useState([])
  const [getLoggedIn, setGetLoggedIn] = useState();
  const [searchData, setSearchData] = useState({
    year: '',
    state: '',
    electionType: ''
  });
  const showStateDropdown = searchData.electionType === "state";


  const [showFilter, setShowFilter] = useState({
    show: false,
    payload: [],
  });
  const navigate = useNavigate();
  const { slug } = useParams();
  const isVerified = localStorage.getItem("accessToken");
  useEffect(() => {
    if (isVerified) setGetLoggedIn(isVerified);
    else {
      navigate("/login");
    }
  }, [isVerified]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSearchData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const submitUserPredictionById = () => {
    dispatch(
      getUserPredictionPost({
        country: localStorage.getItem("country"),
        search: searchText,
        payload: showFilter.payload,
      })
    );
    setShowFilter({
      show: false,
      payload: [],
    });
  };
  const filterRef = useRef(null);
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (filterRef.current && !filterRef.current.contains(event.target)) {
        setShowFilter((prev) => ({ ...prev, show: false }));
      }
    };

    if (showFilter.show) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showFilter.show]);

  const dispatch = useDispatch();
  useEffect(
    function gettingPredictionPost() {
      submitUserPredictionById();
    },
    [render]
  );
  // console.log("name", showFilter);

  const handleFilter = (event) => {
    const { name, checked } = event.target;

    setShowFilter((prev) => ({
      ...prev,
      payload: checked
        ? [...prev.payload, name]
        : prev.payload.filter((item) => item !== name),
    }));
  };
  const handleApplyFilter = () => {
    if (showFilter.payload.length > 0) {
      submitUserPredictionById();
    } else {
      alert("Please select atleast 1 value");
    }
  };

  const handleSearch = () => {
    if (searchText) {
      submitUserPredictionById();
    }
  };
const handleSubmit = () => {
  let payload = {
    country: localStorage.getItem("country"),
    search: searchText,
    payload: showFilter.payload
  };

  // Add electionType ONLY when user selects
  console.log("🚀 ~ handleSubmit ~ searchData.electionType:", searchData.electionType)
  if (searchData.electionType) {
    payload.type = searchData.electionType;
  }

  // Add year ONLY when user selects
  if (searchData.year) {
    payload.year = searchData.year;
  }

  // If electionType = state → send state ONLY
  if (searchData.electionType === "state" && searchData.state) {
    payload.state = searchData.state;
  }

  dispatch(getUserPredictionPost(payload));
};

  const handleReset = () => {
    setShowFilter({
      country: localStorage.getItem("country"),
      show: false,
      payload: [],
    });

    setSearchText("");

    setSearchData({
      electionType: "",
      year: "",
      state: "",
    });

    dispatch(
      getUserPredictionPost({
        country: localStorage.getItem("country"),
        search: "",
        payload: [],
      })
    );
  };


  const handleInput = (e) => {
    console.log(e.target.value);
    setSearchText(e.target.value);
  };
  const { PredictionPostListingResponse } = useSelector(
    (state) => state?.pollWeb
  );
  // console.log("PredictionPostListingResponse", PredictionPostListingResponse);

  const location = useLocation();
  useEffect(() => {
    getyear()
    getState()
  }, [])

  const getyear = async () => {
    try {
      const response = await fetch(
        `${BASE_URL_PP}user/user-post/year-list`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken") || ""
              }`,
          },
        }
      );

      if (response.status === 200) {
        const data = await response.json();
        console.log("data", data);
        setYearList(data.data)

      }
    } catch (error) {
      console.error(`Fetch error for ${"copy-averages"}:`, error);
    }
  };
  const getState = async () => {
    try {
      const response = await fetch(
        `${BASE_URL_PP}user/user-post/state-list`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("accessToken") || ""}`,
          },
          body: JSON.stringify({
            country: localStorage.getItem("country")
          })
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.status) {
        console.log("States data:", data.data);
        setStateList(data.data);
        return data.data;
      } else {
        console.error("API returned false status:", data.msg);
        return [];
      }
    } catch (error) {
      console.error(`Fetch error for state-list:`, error);
      return [];
    }
  };
  return (
    <div className="bg_home flex flex-col pb-8">
      <div className="flex flex-row px-6 md:px-40 gap-4 text-[12px] font-semibold bg-[#E2E7EE]">
        <Link
          to={`/${slug}/general-stories`}
          className={` py-2 ${location.pathname === `/${slug}/general-stories`
            ? "font-bold current-page "
            : "text-[#7F8FA4]"
            }`}
        >
          General Stories
        </Link>

        {getLoggedIn !== null && getLoggedIn !== undefined ? (
          <div>
            {/* {pollPredictionHandler(location)[slug.replace("-", "_")]} */}
            {pollPredictionHandler(location, slug)[slug.replace("-", "_")]}

            <Link
              to={`/${slug}/predictions_post`}
              className={` py-2 mx-3 ${location.pathname === `/${slug}/predictions_post`
                ? "font-bold current-page "
                : "text-[#7F8FA4]"
                }`}
            >
              Prediction
            </Link>
          </div>
        ) : (
          <Link
            to="/login"
            className={`py-2 nav-link-hover-poll ${location.pathname === "/login" ? "font-bold" : "text-[#7F8FA4]"
              }`}
          >
            Polls
          </Link>
        )}
      </div>
      <div className="bg_home md:bg-[#F7F8FA] px-4 min-[955px]:px-40 flex flex-col pb-6 md:py-5">
        <div className="bg-white w-full rounded-xl shadow-sm p-3 md:p-5 overflow-hidden">
          <div className=" sm:flex justify-between items-center mt-3 px-2 mb-3">
            <div className="flex items-center flex-wrap">
              {/* <FormControl sx={{ m: 1, width: "30ch" }} variant="outlined">
                <InputLabel htmlFor="outlined-adornment-password">
                  Search
                </InputLabel>
                <OutlinedInput
                  id="outlined-adornment-password"
                  type={"text"}
                  sx={{ borderRadius: "11px" }}
                  value={searchText}
                  onChange={handleInput}
                  onKeyDown={(e) => e.key === "Enter" && handleSearch()}
                  endAdornment={
                    <InputAdornment position="end" onClick={handleSearch}>
                      <IconButton>
                        <img src={searchicon} alt="searchIcon" />
                      </IconButton>
                    </InputAdornment>
                  }
                  label="Search"
                />
              </FormControl> */}
              <div className="m-2">
                <FormControl sx={{ width: "30ch" }} variant="outlined">
                  <InputLabel id="select-election-type-label">Select Election Type</InputLabel>
                  <Select
                    labelId="select-election-type-label"
                    id="selectElectionType"
                    name="electionType"
                    value={searchData?.electionType}
                    label="Select Election Type"
                    onChange={handleChange}
                    sx={{ borderRadius: "0.75rem" }}
                  >
                    <MenuItem value="national">National</MenuItem>
                    <MenuItem value="state">State</MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="m-2">
                <FormControl sx={{ width: "30ch" }} variant="outlined">
                  <InputLabel id="select-Year-label">Select Year</InputLabel>
                  <Select
                    labelId="select-Year-label"
                    id="selectYear"
                    name="year"
                    value={searchData?.year}
                    label="Select Year"
                    onChange={handleChange}
                    sx={{ borderRadius: "0.75rem" }}
                  >
                    {yearlist?.map((item) => {
                      return (
                        <MenuItem value={item?.year}>{item?.year}</MenuItem>
                      );
                    })}
                  </Select>
                </FormControl>
              </div>
              {showStateDropdown && (
                <div className="m-2">
                  <FormControl sx={{ width: "30ch" }} variant="outlined">
                    <InputLabel id="select-state-label">Select State</InputLabel>
                    <Select
                      labelId="select-state-label"
                      id="selectState"
                      name="state"
                      value={searchData?.state}
                      label="Select State"
                      onChange={handleChange}
                      sx={{ borderRadius: "0.75rem" }}
                    >
                      {statelist?.map((item) => (
                        <MenuItem key={item?.id} value={item?.id}>
                          {item?.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </div>
              )}

              <button
                className="px-4 py-2 border rounded-3xl bg-[#012169] text-white active:scale-95"
                onClick={handleSubmit}
              >
                Apply
              </button>

              <button
                className="px-4 py-2 border rounded-3xl text-white bg-[#012169] transition-all active:scale-95"
                onClick={handleReset}
              >
                <div className="flex items-center gap-1">
                  <p>Reset</p>
                </div>
              </button>
            </div>
            <div className="relative">
              {/* <button
                className="px-4 py-2 border rounded-3xl text-white bg-[#012169] transition-all active:scale-95"
                onClick={() =>
                  setShowFilter((prev) => ({
                    ...prev,
                    show: !showFilter.show,
                  }))
                }
              >
                <div className="flex items-center gap-1">
                  <img src={filtericon} alt="filterIcon" width={15} />
                  <p>Filter</p>
                </div>
              </button> */}
              <div>
                {/* <button
                  className="px-4 py-2 border rounded-3xl text-white bg-[#012169] transition-all active:scale-95"
                  onClick={() =>
                    setShowFilter((prev) => ({
                      ...prev,
                      show: !prev.show,
                    }))
                  }
                >
                  <div className="flex items-center gap-1">
                    <img src={filtericon} alt="filterIcon" width={15} />
                    <p>Filter</p>
                  </div>
                </button> */}

                {showFilter.show && (
                  // <div
                  //   ref={filterRef}
                  //   className="absolute z-10 mt-2 bg-white shadow-lg p-4 rounded"
                  // >
                  <div
                    ref={filterRef}
                    className="absolute w-44 bg-[#F1F3F4] rounded-xl top-[50px] right-[0px] z-10 p-3 text-[12px] space-y-2 shadow-md"
                  >
                    {[
                      { id: "most_followed", label: "Most Followed" },
                      { id: "most_commented", label: "Most Commented" },
                      // { id: "most_shared", label: "Most Shared" },
                    ].map((item) => (
                      <div
                        key={item.id}
                        className="flex items-center space-x-2"
                      >
                        <input
                          type="checkbox"
                          id={item.id}
                          name={item.id}
                          className="appearance-none w-4 h-4 border border-black rounded-sm 
                                checked:bg-black checked:border-black 
                                checked:after:content-['✔'] checked:after:text-white 
                                checked:after:text-[10px] checked:after:flex 
                                checked:after:items-center checked:after:justify-center"
                          onClick={handleFilter}
                        />
                        <label htmlFor={item.id} className="cursor-pointer">
                          {item.label}
                        </label>
                      </div>
                    ))}
                    <div className="flex justify-center mt-3">
                      <button
                        className="px-4 py-1 bg-[#E4002B] text-white rounded-xl transition-all active:scale-95"
                        onClick={handleApplyFilter}
                      >
                        Apply
                      </button>
                    </div>
                  </div>
                  // </div>
                )}
              </div>
              {/* {showFilter.show && (
                <div className="absolute w-44 bg-[#F1F3F4] rounded-xl top-[50px] right-[0px] z-10 p-3 text-[12px] space-y-2 shadow-md">
                  {[
                    { id: "most_followed", label: "Most Followed" },
                    { id: "most_commented", label: "Most Commented" },
                  ].map((item) => (
                    <div key={item.id} className="flex items-center space-x-2">
                      <input
                        type="checkbox"
                        id={item.id}
                        name={item.id}
                        className="appearance-none w-4 h-4 border border-black rounded-sm 
                                checked:bg-black checked:border-black 
                                checked:after:content-['✔'] checked:after:text-white 
                                checked:after:text-[10px] checked:after:flex 
                                checked:after:items-center checked:after:justify-center"
                        onClick={handleFilter}
                      />
                      <label htmlFor={item.id} className="cursor-pointer">
                        {item.label}
                      </label>
                    </div>
                  ))}
                  <div className="flex justify-center mt-3">
                    <button
                      className="px-4 py-1 bg-[#E4002B] text-white rounded-xl transition-all active:scale-95"
                      onClick={handleApplyFilter}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )} */}
            </div>
          </div>
          {PredictionPostListingResponse?.length > 0 ? (
            <div className="my-3">
              {PredictionPostListingResponse?.map((entry, idx) => {
                return (
                  <div className="my-5" key={idx}>
                    <UserPredictionListingComp
                      transformedData={entry?.result}
                      userData={entry?.user}
                      time={entry?.updatedAt}
                      likes={entry?.likes}
                      comments={entry?.comments}
                      description={entry?.description}
                      uuid={entry?.uuid}
                      isLiked={entry?.isLiked}
                      setRender={setRender}
                      isFollow={entry?.isFollow}
                      openCommentId={openCommentId}
                      openShareId={openShareId}
                      setOpenCommentId={setOpenCommentId}
                      setOpenShareId={setOpenShareId}
                    />
                  </div>
                );
              })}
            </div>
          ) : (
            <NothingFound />
          )}
        </div>
      </div>
    </div>
  );
};

export default PredictionPostListing;
